<template>
	<tbody class="smart-tbody accordion">
		<template v-for="(row, id) in requestData">
			<tr
				:key="`tr1-${id}`"
				:class="loadStatus(row)"
				data-toggle="collapse"
				:data-target="`#demo${id || ''}`"
				class="accordion-toggle"
				:id="`tr${id}`"
				data-bs-toggle="collapse"
				aria-expanded="true"
			>
				<template v-for="(col, index) in labels">
					<td
						:key="index"
						:class="GetClass(col)"
						@click="clickInTd(col, row)"
						v-if="col.main == true"
					>
						<span>
							<i
								v-if="col.icon != undefined"
								:class="col.icon"
							></i>
							<span
								:title="
									strip_tags(text_processor(col.data, row))
								"
								:style="col.css != undefined ? col.css : ''"
								v-html="text_processor(col.data, row)"
								class="text"
							>
							</span>
						</span>
					</td>
				</template>
				<table-actions
					:actions="actions"
					:row="row"
					@customAction="$emit('customAction', $event)"
				/>
			</tr>
			<tr :key="`tr2-${id}`">
				<td colspan="12">
					<div
						class="accordian-body collapse"
						colspan="12"
						:id="`demo${id || ''}`"
					>
						<table
							:id="`demo${id || ''}`"
							class="table table--no-margin table-striped table-bordered"
							:data-parent="`#tr${id}`"
						>
							<thead>
								<template v-for="(col, index) in labels">
									<tr v-if="col.multi == true" :key="index">
										<template
											v-for="(object, index) in text_processor(col.data, row)"
										>
											<th
												v-if="
													index == 0 &&
													Object.values(
														col.subLabels
													).includes(name)
												"
												v-bind:key="index"
											>
												<div
													v-for="(value, name) in object"
													@click="clickInTd(col, row)"
													:class="GetClass(col)"
													v-bind:key="value"
												>
													<!-- {{col.subLabels.contains(name)}} -->
													<span>
														<i
															v-if="
																col.icon !=
																undefined
															"
															:class="col.icon"
														></i>
														{{ name }}
													</span>
												</div>
											</th>
										</template>

										<th>
											<span> Ações </span>
										</th>
									</tr>
								</template>
								<!--
										<template v-else>
											<tr>
												<th @click='clickInTd(col, row)' v-for='col in labels' :class='GetClass(col)' v-if='col.main != true'>
													<span>
														<i v-if='col.icon != undefined' :class='col.icon'></i>
														{{col.label}}
													</span>
												</th>
											</tr>
										</template>
									-->
							</thead>
							<tbody>
								<template
									v-if="col.multi == true"
								>
									<div
										v-for="(col, index) in labels"
										:key="index"
									>
										<tr
											v-for="object in text_processor(col.data, row)"
											v-bind:key="object"
										>
											<template
												v-for="(value, key) in object"
											>
												<div
													v-if="col.main != true"
													:key="value"
													:class="GetClass(col)"
												>
													<td
														@click="clickInTd(col, row)"
														v-if="
															Object.values(
																col.subLabels
															).includes(key)
														"
														:key="value"
													>
														<span>
															<i
																v-if="
																	col.icon !=
																	undefined
																"
																:class="col.icon"
															></i>
															<p
																v-else-if="
																	key.includes('data')
																"
															>
																{{ formatData(value) }}
															</p>
															<p
																v-else-if="
																	!key.includes(
																		'anexo'
																	)
																"
															>
																{{ value }}
															</p>
															<p
																v-else-if="
																	key.includes(
																		'anexo'
																	) && value !== ''
																"
															>
																<a
																	:href="value"
																	target="_blank"
																	class="btn button-link btn-xs"
																	style="
																		background-color: #e97f59 !important;
																		color: white !important;
																	"
																>
																	<i
																		class="fa fa-eye"
																	></i>
																</a>
															</p>
														</span>
													</td>
												</div>
											</template>
											<td>
												<table-actions-sub
													:actions="actions"
													:row="object"
													@customAction="
														$emit(
															'customAction',
															$event
														)
													"
												/>
											</td>
										</tr>
									</div>
								</template>

								<!-- <template>
										<tr>
											<td  @click='clickInTd(col, row)' v-for='col in labels' :class='GetClass(col)' v-if='col.main != true'>
												<span>
													<i v-if='col.icon != undefined' :class='col.icon'></i>
													<span
														:title="strip_tags( text_processor(col.data, row) )"
														:style='col.css != undefined ? col.css : ""'
														v-html='text_processor(col.data, row)'
														class='text'>
													</span>
												</span>
											</td>
										</tr>
									</template> -->
							</tbody>
						</table>
					</div>
				</td>
			</tr>
		</template>
	</tbody>
</template>
<script>
	import tableActions from './actions.vue';
	import tableActionsSub from './actionssub.vue';
	import moment from 'moment';

	export default {
		name: 'TableBody',
		props: [
			'labels',
			'requestData',
			'actions',
			'tags',
			'functions',
			'lineStatus',
			'actionsTmp',
		],

		components: { tableActions, tableActionsSub },
		methods: {
			formatData(value) {
				return moment(value).format('DD/MM/YYYY');
			},
			GetClass(col) {
				let css = '';
				css = col.class != undefined ? col.class : ' ';
				css += col.event != undefined ? ' has-hover ' : '';
				return css;
			},
			clickInTd(col, row) {
				if (col.event != undefined) {
					this.$emit('customAction', {
						action: col.event,
						data: row,
					});
				}
			},
			loadStatus(row) {
				if (
					this.lineStatus != null &&
					this.lineStatus != undefined &&
					this.lineStatus != false
				) {
					try {
						return this.lineStatus(row);
					} catch (e) {}
				}
			},
			strip_tags(val) {
				return String(val).replace(/(<([^>]+)>)/gi, '');
			},

			tag_generation(tag) {
				let color = tag.color || 'primary';
				let html = tag.html || '...';
				let icon =
					tag.icon != undefined
						? `<i class='fa fa-${tag.icon}'></i>`
						: '';
				return `<span class='label label-${color}'>${icon} ${html}</span>`;
			},
			functions_processor(val, data, row) {
				if (this.functions == null) return val;
				else {
					let fx = this.functions.find((item) => item.cod == data);
					if (fx == undefined) return val;
					else {
						try {
							return fx.fx(val, row);
						} catch (e) {
							console.log(`ERROR [val: ${val}, data: ${data}]`);
							return 'Error:TableBody:104';
						}
					}
				}
			},
			get_obj_value(data, value) {
				let sData = data.split('.');
				let return_data = undefined;
				sData.forEach((item) => {
					if (typeof return_data == 'object') {
						if (return_data[item] != undefined)
							return_data = return_data[item];
					} else if (value != undefined) {
						if (typeof value[item] != undefined)
							return_data = value[item];
					}
				});
				return return_data;
			},
			text_processor(data, value) {
				const row = value;
				if (typeof data == 'string') {
					if (data.indexOf('.') == -1) {
						value = value[data];
						if (this.tags != null) {
							let tag = this.tags.find(
								(item) =>
									item.cod == data && item.value == value
							);
							if (tag == undefined)
								return this.functions_processor(
									value,
									data,
									row
								);
							else return this.tag_generation(tag);
						} else
							return this.functions_processor(value, data, row);
					} else {
						value = this.get_obj_value(data, value);
						if (this.tags != null) {
							let tag = this.tags.find(
								(item) =>
									item.cod == data && item.value == value
							);
							if (tag == undefined)
								return this.functions_processor(
									value,
									data,
									row
								);
							else return this.tag_generation(tag);
						} else
							return this.functions_processor(value, data, row);
					}
				} else {
					let rData = [];
					data.forEach((item) => {
						if (item.indexOf('.') == -1) {
							let nValue = value[item];
							if (this.tags != null) {
								let tag = this.tags.find(
									(item) =>
										item.cod == data && item.value == nValue
								);
								if (tag == undefined)
									rData.push(
										this.functions_processor(
											nValue,
											data,
											row
										)
									);
								else rData.push(this.tag_generation(tag));
							} else
								rData.push(
									this.functions_processor(nValue, data, row)
								);
						} else {
							rData.push(this.get_obj_value(item, value));
						}
					});
					value = rData.join(' ');
					data = data.join(',');
					if (this.tags != null) {
						let tag = this.tags.find(
							(item) => item.cod == data && item.value == value
						);
						if (tag == undefined)
							return this.functions_processor(value, data, row);
						else return this.tag_generation(tag);
					} else return this.functions_processor(value, data, row);
				}
			},
		},
		mounted() {
			// console.log(this.$slots)
		},
	};
</script>
<style scoped>
	.has-hover {
		cursor: pointer;
	}
</style>
<style>
	.table--no-margin {
		margin: 0 !important;
	}
	.inline-block {
		display: inline-block;
	}
	small.iconed span {
		margin-top: -2px;
	}
	.iconed span {
		width: calc(100% - 18px) !important;
		display: inline-block !important;
	}
	.iconed i {
		float: left;
	}
	.smart-tbody td {
		max-width: 300px;
	}
	.smart-tbody td .label {
		margin-right: 3px;
		margin-bottom: 3px;
		float: left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
	}
	.smart-tbody .text {
		display: block;
		font-size: 12px;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.smart-tbody .two-lines b {
		margin-top: -5px;
	}
	.smart-tbody .two-lines small {
		margin: -3px 0 -20px 0;
	}
	.smart-tbody .two-lines b span,
	.two-lines small span {
		width: 100%;
		overflow: hidden;
	}
	.smart-tbody .two-lines b,
	.two-lines small {
		display: block;
	}
	.smart-tbody .two-lines {
		margin: 2px 0 -9px 0;
		display: block;
		height: 33px;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/accordion-grid/tbody.vue